<template>
  <div>
    <div :style="{ width }" class="up-box">
      <div class="payment marTop10 XYcenter" :style="{ width, height }">
        <i v-if="imgShowBold != '' && !readonly" class="el-icon-delete dele-icon" @click="clearImg"></i>
        <i v-show="!imgShowBold" class="el-icon-plus" style="font-size:30px;"></i>
        <img v-if="coverImageUrl" :src="coverImageUrl" class="avatar pointer" :style="{ width, height }" @click.stop="openView(fileUrl, fileName)">
        <img v-else v-show="imgShowBold" :src="imgShowBold" class="avatar pointer" :style="{ width, height }" @click.stop="openView(fileUrl, fileName)">
        <input type="file" ref="uploadInput" :accept="accept" @change="filesUpFn($event)" v-if="!readonly">
      </div>
      <div style="margin-top:10px;text-align: center;" v-if="fileName != '' || infoTip != ''">
          <span class="name"><span v-if="required" style="color:red">* </span>{{fileName}}</span><span class="info">{{infoTip}}</span>
      </div>
    </div>
    <!--查看大图组件-->
    <show-img ref="showImg" :imgIdList="imgIdList" :imgId="imgId"></show-img>
  </div>
</template>

<script>
import showImg from '@/components/upload/showImg.vue'
export default {
  name: 'upload-file',
  components:{
    showImg
  },
  props:{
    fileUrl: {  // 必填,可传空，注意要加修饰符sync  如:fileUrl.sync=变量
        default: () => {
            return ''
        },
        required: true
    },
    infoname:{ 
        type: Boolean,
        default: false
    },
    required: { 
        type: Boolean,
        default: false
    },
    readonly: { // 只读，详情时用到
        type: Boolean,
        default: false
    },
    accept: { // 上传的文件类型
                type: String, // text/plain, application/zip
                default: '*'
            },
    fileName:{
      type:String,
      default:''
    },
    infoTip:{
      type:String,
      default:''
    },
    width: {
        type: String,
        default: '80px'
    },
    height: {
        type: String,
        default: '80px'
    }
  },
  data () {
    return { 
      imgid:'',
      imgShowBold:'',
      coverImage:'',
      coverImageUrl:'',
      imgApiUrl: `${process.env.FILE_SERVICE}/Admin`, // 获取图片流
      imgIdList:[],
      imgId:[],
    }
  },
  watch: {
    fileUrl: {
        handler(val) {
            if(val == null) val = ''
            this.init(val)
        },
        immediate: true
      },
  },
  methods: {
    openView (src, name) {
        let imgIdList = []
        const imgType = ['.jpg', '.png','.jpeg', '.JPG', '.PNG','.JPEG']
        const hz = '.' + src.split('.')[src.split('.').length - 1]
        let url = src
        if (url.indexOf('http://') == -1 && url.indexOf('https://') == -1) url = '/Admin/' + src
          if (imgType.indexOf(hz) !== -1) {
            let img = {
                id: src,
                name: name
            }
            imgIdList.push(img)
            this.imgId = src

            this.imgIdList = imgIdList
            this.$refs.showImg.isShowBigImg = true
        } else {
          if (url.indexOf('http') != -1) return this.commonJs.Export(url, (name + hz))
          console.log(url)
          this.commonJs.DownLoadImg(url).then(res => {
              if(res){
                this.commonJs.Export(res, (name + hz))
              }
          }).catch(error => {
              this.$message({type: 'error', message: '下载失败'})
          });
      }
    },
    init(val) {
        if (!val) {
          this.imgShowBold = ''
          this.$nextTick(() => {
              if (this.$refs['uploadInput']){
                this.$refs['uploadInput'].value = ''
                this.coverImage = this.coverImageUrl = ''
              }
          })
          return
        }else{
          const imgType = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
          const hz = val.split('.')[val.split('.').length-1]
          if(imgType.indexOf(hz) !== -1 || val.indexOf('http') !== -1){
            if(val.indexOf('http') !== -1){
              this.imgShowBold = this.coverImage = val
            }else{
              this.getImgBoldFn(val, bold => {
                  this.imgShowBold = this.coverImage = bold
              });
            }
          }else{
            this.imgShowBold = val
            if(hz == 'pdf' || hz == 'txt' || hz == 'zip' || hz == 'word'){
              this.coverImageUrl = require(`@/assets/image/${hz}.png`)
            }else{
              this.coverImageUrl = require(`@/assets/image/file.png`)
            }
          }
        }
    },
    clearImg(){
      this.$refs['uploadInput'].value = ''
      this.imgShowBold = this.fileUrl = ''
      this.$emit('updataUrl', '')
    },
    _ajaxFn(url, method, data) {
        return new Promise((reslove, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, true);
            // 添加http头，发送信息至服务器时内容编码类型
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.setRequestHeader('authorization', `Bearer ${localStorage['accessToken']}`);
            if (!data) {
                xhr.responseType = 'blob'
            }
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200 || xhr.status == 304) {
                        reslove(xhr.response);
                    } else {
                        this.$message.error('上传失败，请重新上传！')
                    }
                }
            }
            xhr.send(data);
        })
    },
    getImgBoldFn(value,callBack){
      let url = `${this.imgApiUrl}/${value}`
      this._ajaxFn(url, 'GET').then(resp => {
              console.log(resp)
              callBack(window.URL.createObjectURL(resp));
          }).catch(e => {
              // callBack("./static/img/lost.png");
          });
    },
    filesUpFn(el){
        let _this = this
        let fileObj = el.currentTarget.files;
        let isLt8M = fileObj[0].size / 1024 / 1024 < 50;
        // console.log(fileObj[0])
        
        if (!isLt8M) {
          this.$message({
            message: '上传文件大小不能超过 50MB!',
            type: 'warning',
            duration: 1500
          });
          return false;
        }
        var data = new FormData();
        data.append("action", "UploadVMKImagePath");
        if (this.fileName) {
          data.append("fileAlias", this.fileName);
        } else if (this.fileAlias) {
          data.append("fileAlias", this.fileAlias);
        }
        this.fileInfos = []
        for (let i = 0; i < fileObj.length; i++) {
            this.fileInfos.push({  // 保存上传的文件名
                originalFileName: fileObj[i].name,
                filePath: ''
            })
            data.append("file", fileObj[i]); // 加入文件对象
        }
        let apiUrl =  `${process.env.FILE_SERVICE}/Admin/UploadFiles`
        this._ajaxFn(apiUrl, 'POST', data).then(resp => {
          const dt = JSON.parse(resp)
          // console.log(resp)
          this.init(dt[0])
          this.$emit('updataUrl', dt[0])
        })
      }
  }
}
</script>

<style scoped>
.payment{
    border: 1px dashed #DCDFE6;
    border-radius:8px;
    color: #DCDFE6;
    position: relative;
  }
  .payment input{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  .avatar {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    display: block;
    object-fit: contain;
  }
  .dele-icon{
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 20px;
    cursor: pointer;
    z-index: 99;
  }
  .up-box{
    margin-right: 20px;
  }
  .name{
    color: #999;
    font-size: 12px;
  }
  .info{
    color: #2ba345;
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/vatupload/vatUpLoad.vue